<script>
    export default {
        props: {
            media: Object,
        },
        data() {
            return {
                loading: true,
                showImage: false,
                formats: [],
                checkedFormats: [],
            }
        },
        methods: {
            fetchFormats() {
                this.showImage = true;
                axios.get(Scoop.baseUrl + '/mediaserver/mediaDirectDownload/' + this.media.id).then((response) => {
                    this.formats = response.data.formats;
                    this.loading = false;
                });
            },
            downloadSingleFormat(format) {
                this.downloadFormats(format.id);
            },
            downloadCheckedFormats() {
                this.downloadFormats(_.join(this.checkedFormats, ','));
                this.checkedFormats = [];
            },
            downloadFormats(formats) {
                let url = new URI(Scoop.baseUrl + '/mediaserver/mediaDirectDownload');

                if (formats) {
                    url.addQuery('formats', formats);
                }

                window.location.href = url.toString();
            },
            colorSpace(format) {
                if (format.mediaMetaBitmap && format.mediaMetaBitmap.colorspace) {
                    return _.replace(format.mediaMetaBitmap.colorspace, 'SRGB', 'RGB');
                }

                return '';
            }
        },
        computed: {
            formatsEmpty() {
                return _.isEmpty(this.formats);
            },
            formatsChecked() {
                return !_.isEmpty(this.checkedFormats);
            },
            totalSize() {
                let size = 0;

                _.each(this.checkedFormats, (id) => {
                    let format = _.find(this.formats, (format) => {
                        return format.id == id;
                    });

                    size = size + format.filesize;
                });

                return size;
            },
        }
    }
</script>

<template>
    <Lightbox
            :id="'direct-download-modal-' + media.id"
            :headline="media.filename"
            :large="true"
            @lightboxopening="fetchFormats"
    >
        <slot slot="open-template"></slot>
        <div slot="body">
            <div class="row">
                <div class="col-md-6">
                    <img :src="media.bigPreviewImageUrl" :alt="media.filename" class="img-thumbnail" v-if="showImage">
                </div>
                <div class="col-md-6 white-bg img-thumbnail">
                    <table class="table m-t-md" :class="loading || formatsEmpty ? '' : 'table-striped'">
                        <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Format</th>
                            <th scope="col">Details</th>
                            <th scope="col" class="text-right">Filesize</th>
                            <th scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="loading || formatsEmpty">
                            <td colspan="5">
                                <h4 class="m-t-lg text-center">
                                    <span v-if="loading">
                                        <i class="fa fa-spin fa-cog"></i> Loading...
                                    </span>
                                    <span v-else-if="formatsEmpty">
                                        <i class="fa fa-exclamation-circle"></i> No formats found
                                    </span>
                                </h4>
                            </td>
                        </tr>
                        <tr v-else v-for="(format, name) in formats">
                            <td>
                                <input type="checkbox" :id="format.format" :value="format.id" v-model="checkedFormats">
                            </td>
                            <td><label :for="format.format || name">{{ format.format || name }}</label></td>
                            <td>
                                <strong>{{ format.type }}</strong><br>
                                <span>{{ colorSpace(format) }}</span>
                            </td>
                            <td class="text-right"><span v-if="format.filesize">{{ format.filesize | formatBytes }}</span></td>
                            <td class="text-right">
                                <a @click="downloadSingleFormat(format)"><i class="fa fa-download"></i></a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
        <div slot="footer">
            <button type="button" class="btn btn-white pull-left" data-dismiss="modal"
                    v-text="__('scoop-os.common.close')"></button>
            <button class="btn btn-primary" @click="downloadCheckedFormats" v-show="formatsChecked">
                <span>Download</span>
                <span v-show="totalSize">({{ totalSize | formatBytes }})</span>
            </button>
        </div>
    </Lightbox>
</template>
